import { render } from "./AdminReleases.vue?vue&type=template&id=3a74dd86&scoped=true&ts=true"
import script from "./AdminReleases.vue?vue&type=script&lang=ts"
export * from "./AdminReleases.vue?vue&type=script&lang=ts"

import "./AdminReleases.vue?vue&type=style&index=0&id=3a74dd86&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a74dd86"]])

export default __exports__